module.exports = function(locale, preview) {
  return `

    fragment ComponentWidthFragment on ComponentWidth {
        sys {
          id
        }
        name
        desktopComponentWidth
        smartphoneComponentWidth
        tabletComponentWidth
      }
      
      fragment ImageSetFragment on ImageSet {
        sys {
          id
        }
        styles
        __typename
        name
        altText
        desktopImage {
          title
          url
          fileName
          contentType
        }
        tabletImage {
          title
          url
          fileName
          contentType
        }
        smartphoneImage {
          title
          url
          contentType
          fileName
        }
        componentWidth {
          ... on ComponentWidth {
            ...ComponentWidthFragment
          }
        }
      }
      
      fragment PageMetaDataFragment on PageMetaData {
        sys {
          id
        }
        __typename
        pageTitle
        metaTitle
        metaDescription
        metaKeywords
        openGraphPageTitle
        openGraphDescription
      }
      
      fragment LinkButtonFragment on LinkButton {
        __typename
        sys {
          id
        }
        name
        styles
        link
        linkText
        tooltip
        gaEventClass
        variant
        target
        referencePageCollection(limit: 1) {
          items {
            ... on Product {
              sys {
                id
              }
              gtin
              slug
            }
          }
        }
        componentWidth {
          ... on ComponentWidth {
            ...ComponentWidthFragment
          }
        }
      }
      
      fragment HomeAlertFragment on ContentCard{
        sys{
          id
        }
        name
        text
        primaryImageCollection{
          items{
            name
            image{
              title
              url
              fileName
            }
          
          }
        }
        linkButtonCollection{
          items{
            name
            linkText
            link
          }
        }
      }

      {
        homePageCollection(locale: "${locale}", preview: ${preview}, limit: 1) {
          items {
            sys {
              id
            }
            pageMetaData {
              ...PageMetaDataFragment
            }
            carousel {
              sys {
                id
              }
              componentWidth {
                ...ComponentWidthFragment
              }
              carouselPanelsCollection(limit: 10) {
                items {
                  ... on Carousel {
                    sys {
                      id
                    }
                    title
                    text
                    image {
                      sys {
                        id
                      }
                      ... on ImageSet {
                        ...ImageSetFragment
                      }
                    }
                    callToActionCollection(limit: 2) {
                      items {
                        ... on LinkButton {
                          ...LinkButtonFragment
                        }
                      }
                    }
                    styles
                    classname
                    carouselImage {
                      url
                    }
                  }
                }
              }
            }
            pageContentCollection {
              items {
                sys {
                  id
                }
              }
            }
            mobilePopUp{
              ... on SitePopUp{
              
                variant
                popUpContentCollection(limit:2){
                  items{
                    ...on ImageButton{
                      __typename
                      sys {
                        id
                      }
                      image{
                        url
                      }
                      altText
                      link
                      tooltip
                      gaEventClass
                      gaEventLabel
                  }
                }
              }       
                
              }  
            
          }
            homeAlert {
              ...HomeAlertFragment
            }
          }
         
        }
      }      
    `;
};
